export default function useFormFieldStyleProps() {
  return {
    size: 'lg' as const,
    radius: 'md' as const,
    variant: 'bordered' as const,
    color: 'primary' as const,
    labelPlacement: 'inside' as const,
  }
}
